<template>
  <div>
    <AllCases :tatNotCrossedFlag="tatFlag"></AllCases>
  </div>
</template>

<script>
const AllCases = defineAsyncComponent(() =>
  import("@/components/cases/AllCases")
);
import { defineAsyncComponent } from "vue";
export default {
  components: {
    AllCases,
  },
  data() {
    return {
      tatFlag: true,
    };
  },
};
</script>